import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { AllocationMismatch } from '../../types/allocateMismatch'
import MismatchRow from './MismatchRow'
import MismatchRowSkeleton from './MismatchRow.skeleton'
import useStyles from './styles/MismatchTable.styles'

interface MismatchTableProps {
  loading: boolean
  data: AllocationMismatch[]
  reloadData: () => void
}

export const MismatchTable: React.FC<MismatchTableProps> = ({
  loading,
  data,
  reloadData
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <Typography variant="body1">{getTranslate('RoomType')}</Typography>
        <Typography variant="body1">{getTranslate('Date')}</Typography>
        <Typography variant="body1">
          {getTranslate('CRS Total Allocated Number')}
        </Typography>
        <Typography variant="body1">
          {getTranslate('Sum Of Channel Allocates')}
        </Typography>
        <Typography variant="body1">{getTranslate('Mismatch Type')}</Typography>
        <Typography variant="body1">{getTranslate('Notes')}</Typography>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map((item, index) => (
              <MismatchRowSkeleton
                key={`template-row-skeleton${index.toString()}`}
              />
            ))
        : data.map((mismatch) => (
            <MismatchRow key={mismatch.date} data={mismatch} />
          ))}
    </div>
  )
}

export default MismatchTable
